const t = {
  name: "Prohibited",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 17H8V7H13C14.6523 7 16 8.34772 16 10C16 11.6523 14.6523 13 13 13H10V17ZM10 11H13C13.5477 11 14 10.5477 14 10C14 9.45228 13.5477 9 13 9H10V11Z" fill="currentColor"/>
<path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Prohibited
};
